import { Language } from '@lyceo/homi/settings/util-models';
import { Locale } from 'date-fns';
import { nl, enGB } from 'date-fns/locale';

export function getDateFnsLocaleByLanguage(language: Language): Locale {
  switch (language) {
    case Language.EN:
      return enGB;
    case Language.NL:
      return nl;
    default:
      return nl;
  }
}
